import { useQuery } from "@tanstack/react-query";
import i18next from "i18next";
import { getShippingMethods } from "../../api/apiShipping";

export const useGetShippingMethods = (params) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["shipping-methods", params, i18next.language],
        queryFn: () => getShippingMethods(params),
        keepPreviousData: true,
    });

    const methods = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params?.per_page || 15, total: 0 };

    return { isLoading, error, methods, meta, refetch };
};
